import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-ml-2 p-field"
}
const _hoisted_2 = { class: "p-d-flex p-ai-center p-jc-end" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-briefcase" }, null, -1)
const _hoisted_5 = { class: "p-field" }
const _hoisted_6 = { class: "p-field" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("small", { class: "p-ml-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-info-circle" }),
  /*#__PURE__*/_createTextVNode(" Il risultato della ricerca verrà applicato ai campi sottostanti. ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-envelope" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-euro" }, null, -1)
const _hoisted_10 = { class: "p-formgroup-inline p-mb-3" }
const _hoisted_11 = { class: "p-formgroup-inline p-mb-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-ellipsis-h" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VInputSwitch = _resolveComponent("VInputSwitch")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_VInputText = _resolveComponent("VInputText")!
  const _component_VPassword = _resolveComponent("VPassword")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _component_CityAutocomplete = _resolveComponent("CityAutocomplete")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_AddressAutocomplete = _resolveComponent("AddressAutocomplete")!
  const _component_VCheckbox = _resolveComponent("VCheckbox")!
  const _component_VTextArea = _resolveComponent("VTextArea")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.taker)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_VInputSwitch, {
              name: "is_active",
              labelOn: _ctx.$t('active') ,
              labelOff: _ctx.$t('inactive')
            }, null, 8, ["labelOn", "labelOff"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Fieldset, { class: "p-fluid" }, {
      legend: _withCtx(() => [
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('entity.user_data')), 1)
      ]),
      default: _withCtx(() => [
        (!_ctx.taker || _ctx.requestPending)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(5, (a) => {
              return _createVNode(_component_Skeleton, {
                key: `taker_user_data_${a}`,
                height: "2rem",
                class: "p-mb-2"
              })
            }), 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_VInputText, {
                label: _ctx.$t('user.name') + ' *',
                field: "user_name"
              }, null, 8, ["label"]),
              _createVNode(_component_VInputText, {
                label: _ctx.$t('user.surname') + ' *',
                field: "user_surname"
              }, null, 8, ["label"]),
              _createVNode(_component_VInputText, {
                label: _ctx.$t('user.email') + ' *',
                field: "user_email",
                type: "email"
              }, null, 8, ["label"]),
              _createVNode(_component_VPassword, {
                class: "p-field",
                label: _ctx.$t('user.password'),
                field: "password"
              }, null, 8, ["label"]),
              _createVNode(_component_VPassword, {
                class: "p-field",
                label: _ctx.$t('user.confirm_password'),
                field: "confirm_password",
                autocomplete: "new-password"
              }, null, 8, ["label"])
            ], 64))
      ]),
      _: 1
    }),
    _createVNode(_component_Fieldset, { class: "p-fluid p-mt-3" }, {
      legend: _withCtx(() => [
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('entity.business_data')), 1)
      ]),
      default: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(8, (a) => {
              return _createVNode(_component_Skeleton, {
                key: `company_${a}`,
                height: "2rem",
                class: "p-mb-2"
              })
            }), 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_VInputText, {
                label: _ctx.$t('entity.business_name') + ' *',
                field: "business_name"
              }, null, 8, ["label"]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_FloatLabel, {
                  label: _ctx.$t('entity.business_city') + ' *'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CityAutocomplete, {
                      modelValue: _ctx.businessCity,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.businessCity = $event)),
                      class: _normalizeClass({
              'p-invalid': (_ctx.business_city_meta.touched) && _ctx.business_city_errors?.length
            })
                    }, null, 8, ["modelValue", "class"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                ((_ctx.business_city_meta.touched) && _ctx.business_city_errors?.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.business_city_errors, (e) => {
                      return (_openBlock(), _createElementBlock("p", {
                        key: e,
                        class: "p-error"
                      }, _toDisplayString(_ctx.$t(e)), 1))
                    }), 128))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_AddressAutocomplete, {
                  modelValue: _ctx.business_address,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.business_address = $event)),
                  onSelectedAddress: _ctx.onSelectAddress,
                  label: "Cerca indirizzo"
                }, null, 8, ["modelValue", "onSelectedAddress"]),
                _hoisted_7
              ]),
              _createVNode(_component_VInputText, {
                label: _ctx.$t('entity.business_address') + ' *',
                field: "business_address"
              }, null, 8, ["label"]),
              _createVNode(_component_VInputText, {
                label: _ctx.$t('entity.business_state'),
                field: "business_state"
              }, null, 8, ["label"]),
              _createVNode(_component_VInputText, {
                label: _ctx.$t('entity.business_province'),
                field: "business_province"
              }, null, 8, ["label"]),
              _createVNode(_component_VInputText, {
                label: _ctx.$t('entity.business_postal_code') + ' *',
                field: "business_postal_code"
              }, null, 8, ["label"]),
              _createVNode(_component_VInputText, {
                label: _ctx.$t('entity.sdi'),
                field: "sdi"
              }, null, 8, ["label"]),
              _createVNode(_component_VInputText, {
                label: _ctx.$t('entity.vat') + ' *',
                field: "vat"
              }, null, 8, ["label"]),
              _createVNode(_component_VInputText, {
                label: _ctx.$t('entity.fiscal_code') + ' *',
                field: "fiscal_code"
              }, null, 8, ["label"])
            ], 64))
      ]),
      _: 1
    }),
    _createVNode(_component_Fieldset, { class: "p-fluid p-mt-3" }, {
      legend: _withCtx(() => [
        _hoisted_8,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('entity.contact_details')), 1)
      ]),
      default: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(3, (a) => {
              return _createVNode(_component_Skeleton, {
                key: `contacts_${a}`,
                height: "2rem",
                class: "p-mb-2"
              })
            }), 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_VInputText, {
                label: _ctx.$t('entity.business_tel') + ' *',
                field: "business_tel",
                maxlength: "15"
              }, null, 8, ["label"]),
              _createVNode(_component_VInputText, {
                label: _ctx.$t('entity.pec') + ' *',
                field: "pec",
                type: "email"
              }, null, 8, ["label"]),
              _createVNode(_component_VInputText, {
                label: _ctx.$t('entity.email') + ' *',
                field: "email",
                type: "email"
              }, null, 8, ["label"])
            ], 64))
      ]),
      _: 1
    }),
    _createVNode(_component_Fieldset, { class: "p-fluid p-mt-3" }, {
      legend: _withCtx(() => [
        _hoisted_9,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('entity.costs_section')), 1)
      ]),
      default: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (a) => {
                return _createVNode(_component_Skeleton, {
                  key: `payments_${a}`,
                  height: "2rem",
                  class: "p-mb-2"
                })
              }), 64)),
              _createVNode(_component_Skeleton, {
                height: "5rem",
                class: "p-mb-2"
              })
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_VInputText, {
                  label: "Costo medio spedizione",
                  field: "cost_avg_delivery",
                  type: "number"
                }),
                _createVNode(_component_VInputText, {
                  label: "Fee (%)",
                  field: "perc_fee",
                  type: "number"
                })
              ]),
              _createVNode(_component_VCheckbox, {
                id: "is_time_cost_active",
                field: "is_time_cost_active",
                label: "Attiva costo orario"
              }),
              _createVNode(_component_VCheckbox, {
                id: "is_ignore_cost_zone",
                field: "is_ignore_cost_zone",
                label: "Ignora costi zona"
              }),
              _createVNode(_component_VCheckbox, {
                id: "is_perc_fee_active",
                field: "is_perc_fee_active",
                label: "Attiva percentuale su fee"
              }),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_VCheckbox, {
                  id: "badge_enabled",
                  field: "badge_enabled",
                  label: "Abilita badge in App"
                }),
                _createVNode(_component_VInputText, {
                  label: "Costo orario",
                  field: "badge_cost",
                  type: "number",
                  enabled: "badge_enabled"
                })
              ])
            ], 64))
      ]),
      _: 1
    }),
    _createVNode(_component_Fieldset, { class: "p-fluid p-mt-3" }, {
      legend: _withCtx(() => [
        _hoisted_12,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('entity.other')), 1)
      ]),
      default: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_Skeleton, {
              key: 0,
              height: "5rem",
              class: "p-mb-2"
            }))
          : (_openBlock(), _createBlock(_component_VTextArea, {
              key: 1,
              label: _ctx.$t('entity.note') + ' *',
              field: "note",
              rows: "5",
              cols: "30"
            }, null, 8, ["label"]))
      ]),
      _: 1
    })
  ], 64))
}